import { DataStoreFieldType } from "@/datastore/types";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const DATETIME_RE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;
const BOOL_VALUES = new Set(["true", "false", "yes", "no", "0", "1"]);

/**
 * Infer a datastore field type from sample string values (import preview).
 * Empty strings are ignored; an all-empty sample falls back to TEXT.
 * Mirrors the server-side inference — used only to pre-fill the mapping step.
 */
export function inferType(samples: string[]): DataStoreFieldType {
  const values = samples.filter((s) => s != null && s.trim() !== "");
  if (values.length === 0) return "TEXT";

  const all = (pred: (v: string) => boolean) => values.every(pred);

  if (all((v) => UUID_RE.test(v.trim()))) return "UUID";
  if (all((v) => DATETIME_RE.test(v.trim()))) return "DATETIME";
  if (all((v) => DATE_RE.test(v.trim()))) return "DATE";
  if (all((v) => BOOL_VALUES.has(v.trim().toLowerCase()))) {
    // 0/1-only samples are more likely numeric than boolean
    if (!all((v) => v.trim() === "0" || v.trim() === "1")) return "BOOLEAN";
  }
  if (all((v) => v.trim() !== "" && !Number.isNaN(Number(v.trim())))) {
    return "NUMBER";
  }
  return "TEXT";
}
